import Feathers from './feathers'

class Newspaper extends Feathers {
    getCatesList () {
        return this.request({
            url: `${ this.base }category/GetAllByKind?kind=7`
        })
    }

    getDailyRecommend () {
        return this.request({
            url: `${ this.base }newspaper/whole/recomm?kind=1&top=8`
        })
    }

    getListByCate (categorycode, pageindex = 1, pagesize = 10) {
        const url = `${ this.base }newspaper/whole/bycategory?categorycode=${
        categorycode }&pagesize=${ pagesize }&pageindex=${ pageindex }&itemcount=0`
        
        return this.request({
            url:url
        })

    }

    searchWord (keyword, pageindex = 1, pagesize = 18) {
        const url = `${ this.base }newspaper/whole/search?keyword=${
        keyword }&pagesize=${ pagesize }&pageindex=${ pageindex }`
        return this.request({
            url:url
        })
    }

    getRankList (kind, top = 10) {
        const url = `${ this.base }newspaper/whole/rank?kind=${
        kind }&top=${ top }`
        return this.request({
            url
        })
    }

    getLatestList (top = 10) {
        const url = `${ this.base }newspaper/latest?kind=1&top=${ top }`
        return this.request({
            url
        })
    }

    getDetailInfo (id,year) {
        //api/newspaper/whole/issue?id=1ea60af6-e865-4602-bb04-172485363ec0&date=2020%2F6%2F14
        const url = `${ this.base }newspaper/whole/issue?id=${
        id }&date=${year}`
        return this.request({
            url
        })
    }

    getCatelog (id,pubdate,codename) {
        const url = `${ this.base }newspaper/article/catalog?&codeName=${codename}&pubDate=${pubdate}`
        return this.request({
            url
        })
    }

    getSubResUrl (id, sequence = 1) {
        const url = `${ this.base }audio/file/download?id=${
        id }&sequence=${ sequence }`
        return this.request({
            url
        })
    }

    getPastNewspaper (id,year,month) {
        let url = `${ this.base }newspaper/Issues?id=${id}&year=${year}`
        if(month)
        {
            url+='&month='+month;
        }
        return this.request({
            url:url
        })
    }
    getArticle(articleId, id,year,issue)
    {
        const url = `${ this.base }newspaper/article/detail?&id=${articleId}&codeName=${issue}&pubDate=${year}`
        return this.request({
            url
        })
    }
}

export default Newspaper
